module.exports = "<ngx-spinner></ngx-spinner>\r\n\r\n<router-outlet>\r\n\t\t\r\n</router-outlet>"